'use strict';

var ROMAnalysisCabinFilterFactory = function ROMAnalysisCabinFilterFactory(DataFilter) {
  function ROMAnalysisCabinFilter() {
    DataFilter.call(this, ['rom-analysis-loco-mode', 'rom-analysis-demand-pax-mode', 'rom-analysis-flattened-services-mode', 'rom-analysis-skinny-services-mode', 'rom-analysis-skinny-services-reference-mode'], 'filter-component', 0);
  }
  ROMAnalysisCabinFilter.prototype = Object.create(DataFilter.prototype);
  ROMAnalysisCabinFilter.prototype.filter = function (data, range) {
    range = range[0];
    var filtered = DataFilter.prototype.filter(data, range.cabinCode, 'cabin');
    return filtered;
  };
  return ROMAnalysisCabinFilter;
};
ROMAnalysisCabinFilterFactory.$inject = ['DataFilterFactory'];
module.exports = ROMAnalysisCabinFilterFactory;